import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChange } from '@angular/core';
import { AdUtils } from 'src/app/shared/utils/ad.utils';
import { AdSearchService } from 'src/app/shared/services/adsearch.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { ViewService } from '../../view.service';
import { Subscription } from 'rxjs';
import { FormBuilder } from '@angular/forms';

declare var $: any;

@Component({
    selector: 'shareLink',
    templateUrl: './shareLink.component.html',
    styleUrls: ['./shareLink.component.scss']
})
export class ShareLinkComponent extends AdUtils implements OnInit, OnDestroy, OnChanges {

    @Input() info: any;

    lastStartShare = 0;

    randName:any = '0';

    linkGeneratorSubscription: Subscription;
    protected avatarSubscription: Subscription;
    companiesSubscription: Subscription;

    expireTime: any = [
        { id: 1,  title: '1 dia' },
        { id: 5,  title: '5 dias' },
        { id: 10, title: '10 dias' },
        { id: 15, title: '15 dias' },
        { id: 30, title: '30 dias' },
        { id: 60, title: '60 dias'},
        { id: 90, title: '90 dias'},
        { id: 120, title: '120 dias'}
        //  {id:90,title:'90 dias'}*/
    ];
    tableprice: any = [
        { id: -1, title: 'não exibir' },
        { id: 0, title: 'disponibilidade sem valores' },
        { id: 1, title: 'completa com valores' }
    ];


    isManager = false;
    isManagerActive = false;

    mycontact = true;

    avatarFile: any;

    collapseOptions = false;

    company: any = {};
    companies: any = {};
    profile: any = {};
    owner: any = {};

    companyCanChange = false;
    companyDefault = false;

    showTableprice = false;

    formGroup = this.formBuilder.group({
        //client : [''], 
        mycontact : [true], 
        company : [false],
        owner : [false],
        tableprice : [this.tableprice[0]],
        expire: [this.expireTime[this.expireTime?.length-1]]
      });

    @Input()
    set startShare(val: any) {
        if (val != this.lastStartShare) {
            this.lastStartShare = val;
            this.linkGenerated = 0;
            //this.createShareLink();
            setTimeout(()=>{
                $('#shareModal'+this.randName).modal('show');
            }, 100);
        }
    };

    constructor(
        srs: AdSearchService,
        gs: GeneralService,
        vs: ViewService,
        protected formBuilder: FormBuilder,
        protected cdr: ChangeDetectorRef) {
        super(srs, gs, vs);

        this.companiesSubscription = this.gs.companiesSel$.subscribe(result => {
            this.company = this.gs.getCompanieData(result);
        });

        this.randName = Date.now().toString();
    }

    eventCallback(e) { }

    setDefault() { }

    ngOnInit() {
        this.linkGeneratorSubscription = this.linkGenerator$.subscribe(result => {
            this.cdr.detectChanges();
        });
        this.avatarSubscription = this.gs.avatar$.subscribe((result) => {
            this.avatarFile = result?.tiny || false;
        });

        this.setDefaultData();
    }

    setDefaultData(){

        this.showTableprice = (this.info?.typeComponent == 'building' || this.info?.typeComponent == 'allotment' || this.info?.type_id == '1') && this.gs.restrictedAllowed({ adId: this.info?.adId || this.info?.ad_id, restricted: this.info.restricted, owner_person_id: this.info?.owner?.personId || this.info?.owner_person_id });

        this.companies = this.gs.getCompaniesList();

        this.profile = this.gs.getProfiledata();
        this.mycontact = this.showMyContact(this.profile.perfil_id);
        this.formGroup.controls['mycontact'].setValue(this.mycontact);
        this.formGroup.controls['mycontact'].markAsDirty();

        this.companyCanChange = ["1", "3"].indexOf(this.profile.perfil_id) > -1;

        if (!this.companyCanChange) {
            this.companyDefault = this.companies.accept[0].company_person_id;

            this.formGroup.controls['company'].setValue(this.companyDefault);
            this.formGroup.controls['company'].markAsDirty();
    
            this.mycontact = this.showMyContact(this.companies.accept[0].perfil_id);
            this.formGroup.controls['mycontact'].setValue(this.mycontact);
            this.formGroup.controls['mycontact'].markAsDirty();
        }

        this.owner = this.info?.owner || this.info;
    }

    ngOnDestroy() {
        this.linkGeneratorSubscription?.unsubscribe();
        this.avatarSubscription?.unsubscribe();
    }

    ngOnChanges(changes: { [key: string]: SimpleChange }) {
        if(changes?.info)
            this.setDefaultData();
    }


    showMyContact(perfil_id) {
        if (!perfil_id)
            return false;

        return ["1", "2", "3"].indexOf(perfil_id) > -1
    }

    compareFn(c1: any, c2: any): boolean {
        if (c2 === null)
            return false;

        return c1 == c2;
    }
    
    async makeLink(ev){
        ev.stopPropagation();
        let coordinates = await this.gs.getCurrentPosition();
    
        let data:any = {};
        for(const field in this.formGroup.controls)
            if(this.formGroup.controls.hasOwnProperty(field)){
                data[field] = this.formGroup.controls[field].value;
            }
        
        let shareData:any = {
          user_data : data?.mycontact? 1:0,
          ad_id : this.info?.adId || this.info?.ad_id,
          ad_owner_person_id : this.owner?.personId || this.owner?.company_person_id || this.info?.owner_person_id,
          title : this.info.title,
          expire : data.expire?.id || 10,
          ...coordinates
        };
        if(data?.company){
          shareData.company_person_id = data.company;
          shareData.company_data = 1;
        }
        if(data?.owner){
          shareData.ad_owner_data = 1;
        }
        if(this.info?.unit_id){
          shareData.unit_id = this.info.unit_id;
        }
        if(this.info?.unit_title){
          shareData.unit_title = this.info.unit_title;
        }
        if(this.info?.unit_amount){
          shareData.unit_amountTotal = this.info.unit_amount;
        }
        if((this.info?.typeComponent && (this.info?.typeComponent != 'building' || this.info?.typeComponent == 'allotment')) || (this.info?.type_id && this.info?.type_id !='1')){
          shareData.unit_id = 1;
        }
        if(data?.tableprice){
          shareData.unit_amount = data?.tableprice?.id;
        }

        this.createShareLink(false, shareData);
    }

    copyInput(input){
        input.select();
        document.execCommand('copy');
        input.setSelectionRange(0, 0);
        this.shareLinkCopied = true;
    }


}